

/**
 * Base Api
 */
export const base = {

  POST_LOGIN: '/admin/user/login',
  OUT_LOGIN: `/admin/user/outlogin`,
  UPLOAD_FILE: `/api/upload/uploadfile`,
  CHANGE_PASSWORD: `/admin/heanuser/changeData`,
}

export const heantenant = {
  //租户板块
  TENANT_LIST: `/admin/heantenant/heantenantlist`,
  TENANT_SAVE: `/admin/heantenant/addteant`,
  TENANT_PAGE: `/admin/heantenant/pagelist`,
  TENANT_DETAIL: `/out/heantenant/tenantdesc`,


}


/**
 * User Api
 */
export const user = {
  USER_LIST: `/admin/heanuser/heanuserlist`,
  USER_PAGELIST: `/admin/heanuser/pagelist`,
  USER_INFO: `/admin/heanuser/userInfo`,
  USER_SAVE: `/admin/heanuser/addUser`,
  USER_COPY: `/admin/heanuser/copyUser`,
  USER_DELETE: `/admin/heanuser/delone`,
  USER_CHANGE_DATA: `/admin/heanuser/changeData`,
  USER_LOGOUTTEANT: `/admin/heanuser/logoutteant`,
  USER_SWITCHABLE_USERS: `/admin/heanuser/switchableUsers`,
  USER_SWITCH_ACCOUNT: `/admin/heanuser/switchAccount`,
  USER_EXIT_SWITCH: `/admin/heanuser/exitSwitch`,
  USER_TELEGRAM_GROUP_NOTIFY: `/admin/heanuser/telegram/groupNotify`,
  USER_TELEGRAM_WEEKLY_PAYOUT_NOTIFY: `/admin/heanuser/telegram/weeklyPayoutNotify`,
  USER_TELEGRAM_WEEKLY_PAYOUT_NOTIFY_ONE: `/admin/heanuser/telegram/weeklyPayoutNotifyOne`,

}

export const heanmenu = {
  MENU_SAVE: `/admin/heanmenu/savemenu`,
  MENU_PAGELIST: `/admin/heanmenu/pagelist`,
  MENU_DETAIL: `/admin/heanmenu/detail`,
  MENU_DELTET: `/admin/heanmenu/menudel`,
  MENU_LIST: `/admin/heanmenu/menulist`,
}

export const heanrole = {
  ROLE_LIST: '/admin/heanrole/rolelist',
  ROLE_SAVE: `/admin/heanrole/saverole`,
  ROLE_PAGELIST: `/admin/heanrole/pagelist`,
  ROLE_DELETE: `/admin/heanrole/removerole`,
}

export const stripeuser = {
  STRIP_USER_LIST: '/admin/stripeuser/stripcompanys',
  STRIP_PAGELIST: `/admin/stripeuser/pagelist`,
  STRIP_USERSAVE: `/admin/stripeuser/stripeusersave`,
  STRIP_USERAPIKEY: `/admin/stripeuser/stripeuserapikey`,
  STRIP_USERFIND: `/admin/stripeuser/stripeuserfind`,
  STRIP_USERGROUP: `/admin/stripeuser/stusergroup`,
  STRIP_USERGROUPNEW: `/admin/stripeuser/stusergroupnew`,

  STRIP_MOREUPSTATUS: `/admin/stripeuser/moreupstatus`,
  STRIP_USER_COPY: `/admin/stripeuser/copyChannel`,
  STRIP_USER_WALLET_METHOD_LIST: `/admin/stripeuser/userwalletmethodlist`,

}

export const stripechannel = {
  STRIP_CHANNELFILTER: '/admin/stripechannel/filtername',
  STRIP_CHANNELLIST: `/admin/stripechannel/channellist`,
  STRIP_CHANNELSAVE: `/admin/stripechannel/channelsave`,
  STRIP_CHANNELPAGE: `/admin/stripechannel/pagelist`,
  STRIP_CHANNELDETAIL: `/admin/stripechannel/detail`,
  CHANNEL_CURRENCY_LIST: `/admin/channelcurrency/channelcurrlist`,
  CHANNEL_CURRENCY_SAVE: `/admin/channelcurrency/channelcurrsave`,


}

export const stripeaccount = {
  STRIP_ACCOUNT_LIST: '/admin/stripeaccount/accountlist',
  STRIPE_ACCOUNTUSER: `/admin/stripeaccount/stripeuserkeys`,
  STRIPE_ACCOUNTUSERSAVE: `/admin/stripeaccount/accountusersave`,
  STRIPE_ACCOUNTSAVE: `/admin/stripeaccount/accountsave`,
  STRIPE_ACCOUNT_COPY: `/admin/stripeaccount/copyAccount`,
  STRIPE_ACCOUNTPAGE: `/admin/stripeaccount/pagelist`,
  STRIPE_ACCOUNTDETAIL: `/admin/stripeaccount/detail`,
  STRIPE_ACCOUNTADSPOWER: `/admin/stripeaccount/openadspower`,
  STRIPE_ACCOUNTMONITORCHECK: `/admin/stripeaccount/monitorcheck`,
  STRIPE_ACCOUNT_CHECKOUTFILES: `/admin/stripeaccount/checkoutfiles`,
  STRIPE_ACCOUNT_PUSHCHECKOUTFILES: `/admin/stripeaccount/pushcheckoutfiles`,
  STRIPE_ACCOUNT_TAGLIST: `/admin/stripeaccount/taglist`,
  STRIPE_ACCOUNT_TAGSAVE: `/admin/stripeaccount/tagsave`,
  STRIPE_ACCOUNT_ACCOUNTTAG: `/admin/stripeaccount/accounttag`,
  STRIPE_ACCOUNT_QUOTASTAT: `/admin/stripeaccount/quotastat`,
}

export const stripeurl = {
  STRIP_URLPAGE: `/admin/stripeurl/pagelist`,
  STRIP_URLDETAIL: `/admin/stripeurl/detail`,

}

export const stripecurrency = {
  STRIP_CURRENCY_LIST: '/admin/currency/currencylist',
  STRIP_CURRENCY_FILTERLIST: '/admin/currency/filtercurrency',

}

export const stripelog = {
  STRIP_DASHBOARD: '/admin/stripelog/dashboard',
  STRIP_DASHBOARDALL: '/admin/stripelog/dashboardall',
  STRIPELOG_PAGE: `/admin/stripelog/pagelist`,
  STRIPELOG_EXPORT: `/admin/stripelog/export`,
  STRIPELOG_REFUNDDISPUTE: `/admin/stripelog/refunddispute`,
  STRIPELOG_SYNCSTRIPELOG: `/admin/stripelog/syncstripelog`,
  STRIPELOG_FIND: `/admin/stripelog/stlogfind`,
  STRIPELOG_ORDER_EVENTS: `/admin/stripelog/orderevents`,
  STRIPELOG_FLOW_HOURLY_REPORT: `/admin/stripelog/flowhourlyreport`,
  STRIPELOG_REPUSH_MERCHANT_ALERT: `/admin/stripelog/repushmerchantalert`,
  STRIPELOG_PUSH_DISPUTE_ALERT: `/admin/stripelog/pushdisputealert`,
  STRIPELOG_REFUND: `/admin/stripelog/refundorder`,
  STRIPELOG_CUSTOMER_EXPORT: `/admin/stripelog/customerexport`,
  STRIPELOG_CANCEL: `/admin/stripelog/canclesub`,
  STRIPELOG_DISPUTEOPEN: `/admin/stripelog/disputeOpen`,
  STRIPELOG_DISPUTEWARN: `/admin/stripelog/disputeWarn`,
  STRIPELOG_DISPUTEHANDLE: `/admin/stripelog/disputeHandle`,


}

export const operationlogs = {
  OPERATIONLOGS_PAGE: `/admin/operationlogs/pagelist`,
}

export const shippinginfo = {
  SHIPPINGINFO_PAGE: `/admin/shippinginfo/pagelist`,
  SHIPPINGINFO_SAVE: `/admin/shippinginfo/shippinginfosave`,
  SHIPPINGINFO_IMPORT: `/admin/shippinginfo/shippinginfoimport`,
  SHIPPINGINFO_EXPORT: `/admin/shippinginfo/shippinginfoexport`,
  SHIPPINGINFO_CREATE: `/admin/shippinginfo/shippinginfocreate`,
  SHIPPINGINFO_DETAIL: `/admin/shippinginfo/detail`,
  SHIPPINGINFO_BUYSHIPPNUM: `/admin/shippinginfo/buyshippnum`,
  SHIPPINGINFO_SHIPPINGCLEAR: `/stlogshipping/shippinginfo/importdata`,
  SHIPPINGINFO_PAYPAL_SYNC: `/admin/shippinginfo/paypalsync`,
  SHIPPINGINFO_MISSING_TRACK_COUNT: `/admin/shippinginfo/missingTrackCount`,
  SHIPPINGINFO_TAGLIST: `/admin/shippinginfo/taglist`,
  SHIPPINGINFO_TAGSAVE: `/admin/shippinginfo/tagsave`,
  SHIPPINGINFO_SHIPPINGTAG: `/admin/shippinginfo/shippingtag`,
}


export const payoutinfo = {
  PAYINFO_DASHBOARD: '/admin/payoutinfo/dashboard',
  STRIPE_PAYOUTIMPORT: `/admin/payoutinfo/importData`,
  STRIPE_PAYOUTPAGE: `/admin/payoutinfo/pagelist`,
  STRIPE_PAYOUTDETAIL: `/admin/payoutinfo/payoutdetail`,
  STRIPE_PAYOUTSTATUS: `/admin/payoutinfo/payoutstatus`,
  STRIPE_PAYOUT_NOTIFY_RECONCILE: `/admin/payoutinfo/notifyReconcile`,
  STRIPE_PAYOUTSUMPRICE: `/admin/payoutinfo/sumprice`,
  STRIPE_PAYOUTCREATE: `/admin/payoutinfo/paymentcreate`,
  STRIPE_PAYOUTEXPORT: `/admin/payoutinfo/export`,
  STRIPE_REFUND: `/admin/payoutinfo/refund`,
  STRIPE_PAYOUTREFUND: `/admin/payoutinfo/refundPayoutinfo`,
  STRIPE_PAYOUTREFRESHCREATE: `/admin/payoutinfo/refreshcreate`,
  STRIPE_PAYOUMOREHANG: `/admin/payoutinfo/morehang`,
  STRIPE_PAYRMORELIST: `/admin/payoutinfo/payrmorelist`,
  STRIPE_PAYRECORDMORE: `/admin/payoutinfo/payrecordmore`,
  STRIPE_CUSTOMER_PERIOD_SUM: `/admin/payoutinfo/customerperiodsum`,



}

export const payoutinfodeduction = {
  DEDUCTION_SAVE: `/admin/deduction/deductionsave`,
  DEDUCTION_PAGE: `/admin/deduction/pagelist`,
  DEDUCTION_CREATE_RECORD: `/admin/deduction/createrecord`,
  DEDUCTION_DEL: `/admin/deduction/deductiondel`,
  DEDUCTION_EXPORT: `/admin/deduction/export`,
}

export const paymentrecord = {
  PAYMENTRECORD_MARGINSAVE: `/admin/paymentrecord/marginmoresave`,
  PAYMENTRECORD_MORESAVE: `/admin/paymentrecord/moresave`,
  PAYMENTRECORD_SETTLEMENTS: `/admin/paymentrecord/settlements`,
  PAYMENTRECORD_SAVE: `/admin/paymentrecord/paymentrecordsave`,
  PAYMENTRECORD_CREATE_COMPENSATE: `/admin/paymentrecord/createcompensate`,
  PAYMENTRECORD_NOTIFY_PAID: `/admin/paymentrecord/notifyPaid`,
  PAYMENTRECORD_NOTIFY_PAID_PREVIEW: `/admin/paymentrecord/notifyPaidPreview`,
  PAYMENTRECORD_PAGE: `/admin/paymentrecord/pagelist`,
  PAYMENTRECORD_EXPORT: `/admin/paymentrecord/export`,
  PAYMENTRECORD_EXPORT_DETAIL: `/admin/paymentrecord/exportdetail`,
}

export const paymentmethod = {
  PAYMENTMETHOD_LIST: `/admin/paymentmethod/paymentmethodlist`,
  PAYMENTMETHOD_ACCOUNT_LIST: `/admin/paymentmethod/methodaccountlist`,
  PAYMENTMETHOD_PAGE: `/admin/paymentmethod/pagelist`,
  PAYMENTMETHOD_SAVE: `/admin/paymentmethod/savemethod`,
}

export const heanbanconfig = {
  BANCONFIG_LIST: `/admin/heanbanconfig/banconfiglist`,
}

export const stblacklist = {
  ST_BLACK_SAVE: `/admin/stblack/stblacksave`,
  ST_BLACK_CHANGE: `/admin/stblack/stblackchange`,
  ST_BLACK_PAGE: `/admin/stblack/pagelist`,

}

export const stshopify = {
  ST_SHOPIFY_LIST: `/admin/stshopify/shopifylist`,
  ST_SHOPIFY_SAVE: `/admin/stshopify/stshopifysave`,
  ST_SHOPIFY_PAGE: `/admin/stshopify/pagelist`,


}

export const stripeusergroup = {
  ST_USERGROUP_LIST: `/admin/stusergroup/stusergrouplist`,
  ST_USERGROUP_SAVE: `/admin/stusergroup/stusergroupsave`,
  ST_USERGROUP_PAGE: `/admin/stusergroup/pagelist`,
}

export const stripecheckout = {
  ST_CHECKOUT_LIST: `/admin/stcheckout/checkoutlist`,
  ST_CHECKOUT_SAVE: `/admin/stcheckout/checkoutsave`,
  ST_CHECKOUT_BATCH_BIND: `/admin/stcheckout/batchBindAccount`,
  ST_CHECKOUT_PAGE: `/admin/stcheckout/pagelist`,
  ST_CHECKOUT_DETAIL: `/admin/stcheckout/detail`,
}

export const stdraftorder = {
  ST_DRAFORDER_SAVE: `/admin/draforder/createdraf`,
  ST_DRAFORDER_PAGE: `/admin/draforder/pagelist`,
}

export const transferorder = {
  TRANSFERORDER_PAGE: `/admin/transferorder/pagelist`,
}

/**
 * Markdown 读写：后端 MarkdownDocAdminController，目录由 xpay-doc.storage-dir 配置
 * GET ?fileName= 缺省为 index.md；POST body: { content, fileName? }
 */
export const xpaydoc = {
  CONTENT: `/admin/xpaydoc/content`,
  SAVE: `/admin/xpaydoc/save`,
  SHARE: `/admin/xpaydoc/share`,
  SHARE_RENEW: `/admin/xpaydoc/share/renew`,
  OPEN_CONTENT: `/open/xpaydoc/content`,
}

export const basedomain = {
  BASE_DOMAIN_LIST: `/admin/basedomain/list`,
  BASE_DOMAIN_SAVE: `/admin/basedomain/basedomainsave`,
  BASE_DOMAIN_PAGE: `/admin/basedomain/pagelist`,
  BASE_DOMAIN_MYPAYFILES: `/admin/basedomain/mypayfiles`,
  BASE_DOMAIN_PUSHMYPAYFILES: `/admin/basedomain/pushmypayfiles`,
}






